import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import TimeBubble from "./TimeBubble";
import TimelineSlider from "./TimelineSlider";
import {CardTitle} from "../Kit/Kit";

const StyledBodyContainer = BodyContainer.extend`

`;

const BubbleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  
  @media(min-width: 768px) {
      margin: 200px 0;
  }
`;

const Timeline = (props) => {
    const {timeline} = props;
    return (
      <StyledBodyContainer>
          <CardTitle>H & N TIMELINE</CardTitle>
          <BubbleContainer>
              {timeline.map((i, index) => {
                    const top = (index % 2 === 0);
                    return (
                      <TimeBubble
                        key={index}
                        date={i.year}
                        text={i.text}
                        top={top}
                      />
                    )
                }
              )
              }
              <TimelineSlider data={timeline}/>
          </BubbleContainer>

      </StyledBodyContainer>
    );
};

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/Timeline.js